const brandColor = '#41A017'

const commonStyles = {
  control: (base, state) => ({
    ...base,
    boxShadow: 0,
    borderRadius: 8,
    borderColor: state.isFocused ? brandColor : '#a6a6a6',
    '&:hover': {
      borderColor: state.isFocused ? brandColor : '#a6a6a6',
    },
  }),

  indicatorsContainer: (styles) => ({
    ...styles,
    height: 30,
    alignSelf: 'center',
  }),

  noOptionsMessage: (styles) => ({
    ...styles,
    backgroundColor: 'white',
    color: brandColor,
  }),

  option: (styles, { isDisabled, isFocused }) => ({
    ...styles,
    backgroundColor: isDisabled ? null : isFocused ? '#cae4b8' : null,
    color: isDisabled ? '#a6a6a6' : '#666666',
    cursor: isDisabled ? 'not-allowed' : 'default',
  }),
}

export const colourStyles = {
  ...commonStyles,

  clearIndicator: (styles) => ({
    ...styles,
    color: brandColor,
  }),

  dropdownIndicator: (styles, state) => ({
    ...styles,
    color: state.isDisabled ? '#a6a6a6' : brandColor,
  }),

  indicatorSeparator: () => ({
    borderColor: 'white',
  }),

  multiValue: (styles, state) => ({
    ...styles,
    backgroundColor: state.isDisabled ? '#e5e5e5' : 'white',
  }),

  multiValueLabel: (styles, state) => ({
    ...styles,
    color: state.isDisabled ? '#a6a6a6' : brandColor,
    backgroundColor: state.isDisabled ? '#e5e5e5' : 'white',
    fontSize: 'medium',
    boxShadow: 0,
    borderColor: state.isFocused ? brandColor : '#a6a6a6',
    '&:hover': {
      borderColor: state.isFocused ? brandColor : '#a6a6a6',
    },
  }),

  multiValueRemove: (styles, state) => ({
    ...styles,
    backgroundColor: state.isDisabled ? '#e5e5e5' : 'white',
    color: state.isDisabled ? '#a6a6a6' : brandColor,
    ':hover': {
      backgroundColor: state.isDisabled ? '#e5e5e5' : '#cae4b8',
      color: brandColor,
    },
  }),

  menu: (styles) => ({
    ...styles,
    zIndex: 9999,
  }),
}

export const colourStylesSmall = {
  commonStyles,

  clearIndicator: (styles) => ({
    ...styles,
    color: brandColor,
  }),

  dropdownIndicator: (styles) => ({
    ...styles,
    color: brandColor,
  }),

  indicatorSeparator: () => ({
    borderColor: 'white',
  }),

  multiValue: (styles) => ({
    ...styles,
    backgroundColor: 'white',
  }),

  multiValueLabel: (styles, state) => ({
    ...styles,
    paddingTop: 2,
    paddingright: 5,
    paddingBottom: 2,
    paddingLeft: 5,
    color: brandColor,
    backgroundColor: 'white',
    fontSize: 'small',
    boxShadow: 0,
    borderColor: state.isFocused ? brandColor : '#a6a6a6',
    '&:hover': {
      borderColor: state.isFocused ? brandColor : '#a6a6a6',
    },
  }),

  multiValueRemove: (styles, state) => ({
    ...styles,
    backgroundColor: state.isDisabled ? '#e5e5e5' : 'white',
    color: brandColor,
    ':hover': {
      backgroundColor: '#e5e5e5',
      color: brandColor,
    },
  }),

  menu: (styles) => ({
    ...styles,
    zIndex: 9999,
  }),

  option: (styles, { isDisabled, isFocused }) => ({
    ...styles,
    backgroundColor: isDisabled ? null : isFocused ? '#e5e5e5' : null,
    color: isDisabled ? '#a6a6a6' : '#666666',
    cursor: isDisabled ? 'not-allowed' : 'default',
  }),
}

export const colourStylesStore = {
  container: (styles) => ({
    ...styles,
    width: '100%',
    height: '100%',
    borderColor: brandColor,
  }),

  control: (styles) => ({
    ...styles,
    background: brandColor,
    height: '100%',
    border: 'none',
    borderRadius: '0',
    borderColor: brandColor,
    minHeight: 50,
  }),

  singleValue: (styles) => ({
    ...styles,
    color: 'white',
    fontWeight: 'bold',
  }),

  placeholder: (styles) => ({
    ...styles,
    color: 'white',
    fontWeight: 'bold',
    fontStyle: 'normal',
  }),

  dropdownIndicator: (styles) => ({
    ...styles,
    color: 'white',
  }),

  valueContainer: (styles) => ({
    ...styles,
    marginLeft: 10,
  }),

  indicatorSeparator: (styles) => ({
    ...styles,
    display: 'none',
  }),

  menuList: (styles) => ({
    ...styles,
    minHeight: '40vh',
  }),
}

export const upSideDownSelect = {
  ...colourStyles,

  dropdownIndicator: (styles, state) => ({
    ...styles,
    transform: 'rotate(180deg)',
    color: state.isDisabled ? '#a6a6a6' : brandColor,
  })
}
